export enum DeepzoomStatus {
    notStarted = 1,
    inProgress = 2,
    finished = 3,
    failed = 4
}